import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import props from './attrs/props'
import watch from './attrs/watch'
import Casting from './components/Casting/Index'
import EventSupport from './components/EventSupport/Index'
import BarsAndRestaurants from './components/BarsAndRestaurants/Index'
import MasterOfCeremonies from './components/MasterOfCeremonies/Index'

export default {
    name: 'WorkProfile',
    computed,
    data,
    methods,
    mounted,
    props,
    watch,
    components: {
        Casting,
        EventSupport,
        BarsAndRestaurants,
        MasterOfCeremonies
    }
}
